import { render, staticRenderFns } from "./scrm.vue?vue&type=template&id=69cc69a6&scoped=true&"
import script from "./scrm.vue?vue&type=script&lang=js&"
export * from "./scrm.vue?vue&type=script&lang=js&"
import style0 from "./scrm.vue?vue&type=style&index=0&id=69cc69a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc69a6",
  null
  
)

export default component.exports